import { Modal } from "react-bootstrap";
import { BeatLoader } from "react-spinners";

const LoaderSpinner = (props: any) =>{

    return(
        <>
            <Modal size="lg" show={props.Show} centered>
                <Modal.Body>
                    <div className="d-flex justify-content-center">
                        <label>
                            <BeatLoader color={props.color} />
                        </label>                        
                        <label className="h5 text-center" style={{color: props.color}}>
                            {props.text}
                        </label>
                        <label>
                            <BeatLoader color={props.color} />
                        </label>
                    </div>
                </Modal.Body>
            </Modal>
        </> 
    );
};

export default LoaderSpinner;